import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RequestNewBrowserUrl,
  RequestNewUrl,
  ResetUrlError,
} from "../../../../../../store/actions/dashboardActions";

import Modal from "../../../../../UI/Modal/Modal";
import Content from "../../../../../common/SubmitPopup/Content/Content";
import SubmitPopup from "../../../../../common/SubmitPopup/SubmitPopup";
import Warning from "../../../../../common/Warning/Warning";
import Backdrop from "../../../../../UI/Backdrop/Backdrop";
import FileCardButton from "../../../../../UI/FileCardButton/FileCardButton";
import UrlIcon from "../../../../../Icon-SVG/UrlIcon";
import DownloadIcon from "../../../../../Icon-SVG/DownloadIcon";

import { desktopVmOptionsURL } from "../../../../../common/SubmitPopup/constants";

import "./styles.scss";
import { prepareSubmitData } from "../../../../../common/SubmitPopup/utils";

const URL_REGEX = /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]+)?(\/\S*)?$/;
// const URL_REGEX =
//   /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|(?:\d{1,3}\.){3}\d{1,3})(:[0-9]+)?(\/\S*)?$/;

const AnalyzeUrl = () => {
  const [urls, setUrls] = useState([]);
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [browserUrls, setBrowserUrls] = useState([]);
  const [modalActive, setModalActive] = useState(false);
  const [submitFile, setSubmitFile] = useState([{ fileName: "to-be-determined.urlist" }]);
  const dispatch = useDispatch();
  const urlError = useSelector((state) => state.dashboard.urlError);
  const urlLoading = useSelector((state) => state.dashboard.urlLoading);
  const urlMessage = useSelector((state) => state.dashboard.urlMessage);
  const vms = useSelector((state) => state.dashboard.vms);

  const handleUrlSubmit = () => {
    if (urls.length === 0) {
      setError("Please enter at least one URL");
      setShow(true);
      return;
    }
    dispatch(RequestNewUrl({ urls, message: "Submitting downloaded attachment file..." }));
    setUrls([]);
  };

  const handleModalActive = () => {
    const browserUrls = [];
    const lines = urls.filter((l) => l !== "").map((l) => l.trim());

    lines.forEach((line) => {
      if (!URL_REGEX.test(line)) {
        setError(`${line} is not a valid URL.`);
        setShow(true);
        return;
      } else {
        browserUrls.push(line);
      }
    });

    if (browserUrls.length === 0) {
      setError("No valid URL");
      setShow(true);
      return;
    } else if (!desktopVmOptionsURL.some((vmOption) => vms.includes(vmOption.id))) {
      setError("No vm available. Refresh the page and try again.");
      setShow(true);
    } else {
      const firstUrl = new URL(browserUrls[0]);
      let domain = firstUrl.hostname;
      domain = domain.replace(/^www\./, "");
      domain = domain.split(".")[0];
      setSubmitFile([{ fileName: `${domain}.urlist` }]);
      setModalActive(true);
      setBrowserUrls(browserUrls);
    }
  };

  const handleBrowserSubmit = (selectedFiles) => {
    const preparedSubmitData = prepareSubmitData(selectedFiles, desktopVmOptionsURL);
    dispatch(
      RequestNewBrowserUrl({
        submitData: preparedSubmitData,
        fileName: submitFile[0].fileName,
        urls: browserUrls,
        message: "Submitting urls...",
      }),
    );
  };

  useEffect(() => {
    if (urlError) {
      setError(urlError.response?.data?.message || "URL submission failed.");
      setShow(true);
    }
    dispatch(ResetUrlError());
  }, [urlError]);

  const handleChange = (e) => {
    const { value } = e.target;
    const newUrls = value.split("\n").filter((url) => url.trim() !== "");
    setUrls(newUrls);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setUrls([...urls, ""]);
    }
  };

  const renderContent = (
    currentFileIndex,
    activeOs,
    selectedFiles,
    checkboxInputChangeHandler,
    enforceRuntimeChangeHandler,
    otherInputsChangeHandler,
  ) => (
    <Content
      currentFileIndex={currentFileIndex}
      activeOs={activeOs}
      selectedFiles={selectedFiles}
      show={{ networkTraffic: true }}
      disableNetwork={true}
      onCheckboxInputChange={checkboxInputChangeHandler}
      onEnforceRuntimeChange={enforceRuntimeChangeHandler}
      onOtherInputsChange={otherInputsChangeHandler}
    />
  );

  return (
    <div className="analyze-url">
      <textarea
        className="analyze-url__input"
        value={urls.join("\n")} //
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="https://www.test.com/malicious"
      />
      <div className="analyze-url__button-block">
        <FileCardButton onClick={handleUrlSubmit}>
          <DownloadIcon width={23} height={21} mtop="3px" />
          <p>Fetch</p> 
        </FileCardButton>
        <FileCardButton onClick={handleModalActive}>
          <UrlIcon />
          <p>Browse</p>
        </FileCardButton>
      </div>
      <Warning
        onClickOk={() => setShow(false)}
        show={show}
        setShow={setShow}
        text={error}
        article="Warning"
        cancelDisable={true}
        textOK="Okay"
      />
      {modalActive && (
        <Modal active={modalActive} setActive={setModalActive} type="analyze-url-submit-popup">
          <SubmitPopup
            selectedFiles={submitFile}
            setSelectedFiles={setSubmitFile}
            vmOptions={desktopVmOptionsURL.filter((vmOption) => vms.includes(vmOption.id))}
            onClose={() => setModalActive(false)}
            onSubmit={handleBrowserSubmit}
            renderContent={renderContent}
            showApplyAll={false}
            showFileList={false}
          />
        </Modal>
      )}
      <Backdrop show={urlLoading} message={urlMessage} />
    </div>
  );
};

export default AnalyzeUrl;
